import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IaAprendizadoWhatsApp, IaConfiguracaoCliente, IaLacuna, IaScriptPrompt, IaWhatsAppPlano } from '../../core/models/ia/ia';
import { Vendedor } from '../../core/models/vendedores/vendedor';
import { WhatsAppOfficialEtapa } from '../../core/models/whatsapp-oficial/whatsapp-oficial-etapa';
import { IaService } from '../../core/services/ia/ia.service';
import { VendedorService } from '../../core/services/vendedores/vendedor.service';
import { WhatsAppOfficialService } from '../../core/services/whatsapp-oficial/whatsapp-oficial.service';

@Component({
  selector: 'app-ia-config',
  templateUrl: './ia-config.component.html',
  styleUrls: ['./ia-config.component.css'],
  standalone: false
})
export class IaConfigComponent implements OnInit {
  configuracao: IaConfiguracaoCliente = new IaConfiguracaoCliente();
  carregando: boolean = false;
  salvando: boolean = false;
  podeConfigurar: boolean = false;

  conhecimentos: IaScriptPrompt[] = [];
  conhecimentoEdicao: IaScriptPrompt = null;
  salvandoConhecimento: boolean = false;
  enviandoArquivo: boolean = false;
  aprendizado: IaAprendizadoWhatsApp = new IaAprendizadoWhatsApp();
  lacunas: IaLacuna[] = [];
  lacunaPerguntaEmEnsino: string = null;

  planos: IaWhatsAppPlano[] = [];
  planoEdicao: IaWhatsAppPlano = null;
  salvandoPlano: boolean = false;

  mercadoPagoPublicToken: string = "";
  mercadoPagoAccessToken: string = "";
  salvandoMercadoPago: boolean = false;

  etapas: WhatsAppOfficialEtapa[] = [];
  novaEtapa: WhatsAppOfficialEtapa = new WhatsAppOfficialEtapa();
  tiposEtapaWhatsApp: string[] = ['ABERTO', 'ATENDIMENTO', 'PIPELINE', 'GANHO', 'PERDA'];
  vendedores: Vendedor[] = [];

  constructor(
    private iaService: IaService,
    private toastr: ToastrService,
    private whatsAppOfficialService: WhatsAppOfficialService,
    private vendedorService: VendedorService
  ) { }

  salvarMercadoPagoTokens() {
    if (this.salvandoMercadoPago) return;

    if (!this.mercadoPagoPublicToken && !this.mercadoPagoAccessToken) {
      this.toastr.warning("", "Informe o Public Key ou o Access Token do Mercado Pago.");
      return;
    }

    this.salvandoMercadoPago = true;
    this.iaService.salvarMercadoPagoTokens(this.mercadoPagoPublicToken, this.mercadoPagoAccessToken).subscribe(salvou => {
      this.salvandoMercadoPago = false;
      if (salvou) {
        this.toastr.success("", "Credenciais do Mercado Pago salvas com sucesso.");
        this.mercadoPagoPublicToken = "";
        this.mercadoPagoAccessToken = "";
      }
    }, () => this.salvandoMercadoPago = false);
  }

  ngOnInit() {
    this.podeConfigurar = localStorage.getItem("is_master") == "true" || localStorage.getItem("is_diretor") == "true";
    if (this.podeConfigurar) this.carregar();
  }

  carregar() {
    this.carregando = true;
    this.iaService.getConfiguration().subscribe(configuracao => {
      this.configuracao = configuracao || new IaConfiguracaoCliente();
      this.configuracao.api_key = "";
      this.carregando = false;
    }, () => this.carregando = false);

    this.carregarConhecimentos();
    this.carregarAprendizado();
    this.carregarPlanos();
    this.carregarEtapasKanban();
    this.carregarVendedores();
  }

  carregarVendedores() {
    this.vendedorService.getByGuidClienteNapis().subscribe(vendedores => {
      this.vendedores = (vendedores || [])
        .filter(v => v != null && v.is_active != false && v.is_master_seller == true)
        .sort((a, b) => (a.fullname || "").localeCompare(b.fullname || ""));
    });
  }

  getEscopoNome(item: { seller_id?: number, seller_nome?: string }): string {
    if (item == null || item.seller_id == null || item.seller_id == 0) return "Todas as unidades";
    if (item.seller_nome) return item.seller_nome;

    let vendedor = this.vendedores.find(v => v.id == item.seller_id);
    return vendedor != null ? vendedor.fullname : "Unidade " + item.seller_id;
  }

  /* Etapas do Kanban */

  carregarEtapasKanban() {
    this.whatsAppOfficialService.getStages().subscribe(
      etapas => this.etapas = (etapas || []).sort((a, b) => a.ordem - b.ordem),
      error => { console.log("Erro: " + error) }
    );
  }

  adicionarEtapa() {
    if (this.novaEtapa.nome == null || this.novaEtapa.nome.trim() == "") {
      this.toastr.warning("", "Informe o nome da etapa.");
      return;
    }

    this.novaEtapa.ordem = this.getProximaOrdem();

    this.whatsAppOfficialService.addStage(this.novaEtapa).subscribe(
      adicionado => {
        if (adicionado) {
          this.toastr.success("", "Etapa adicionada com sucesso.");
          this.novaEtapa = new WhatsAppOfficialEtapa();
          this.carregarEtapasKanban();
        }
      }
    );
  }

  salvarEtapa(etapa: WhatsAppOfficialEtapa) {
    this.whatsAppOfficialService.updateStage(etapa).subscribe(
      alterado => {
        if (alterado) {
          this.toastr.success("", "Etapa atualizada com sucesso.");
          this.carregarEtapasKanban();
        }
      }
    );
  }

  excluirEtapa(etapa: WhatsAppOfficialEtapa) {
    if (etapa == null || etapa.permite_exclusao == false) {
      return;
    }

    this.whatsAppOfficialService.deleteStage(etapa.id).subscribe(
      removido => {
        if (removido) {
          this.toastr.success("", "Etapa removida com sucesso.");
          this.carregarEtapasKanban();
        }
      }
    );
  }

  moverEtapa(etapa: WhatsAppOfficialEtapa, direcao: number) {
    let etapasMoveis = this.etapas.filter(x => x.is_system == false).sort((a, b) => a.ordem - b.ordem);
    let indiceAtual = etapasMoveis.findIndex(x => x.id == etapa.id);
    let indiceDestino = indiceAtual + direcao;

    if (indiceAtual < 0 || indiceDestino < 0 || indiceDestino >= etapasMoveis.length) {
      return;
    }

    let etapaAtual = etapasMoveis[indiceAtual];
    etapasMoveis[indiceAtual] = etapasMoveis[indiceDestino];
    etapasMoveis[indiceDestino] = etapaAtual;

    let ids = etapasMoveis.map(x => x.id);

    this.whatsAppOfficialService.reorderStages(ids).subscribe(
      ordenado => {
        if (ordenado) {
          this.toastr.success("", "Etapas reordenadas com sucesso.");
          this.carregarEtapasKanban();
        }
      }
    );
  }

  getProximaOrdem(): number {
    if (this.etapas.length == 0) {
      return 3;
    }

    let etapasPipeline = this.etapas.filter(x => x.tipo == "PIPELINE");

    if (etapasPipeline.length == 0) {
      return 3;
    }

    return Math.max.apply(null, etapasPipeline.map(x => x.ordem)) + 1;
  }

  /* Planos & Pagamento no Chat */

  carregarPlanos() {
    this.iaService.getPlanosGestaoWhatsApp().subscribe(planos => {
      this.planos = planos || [];
    });
  }

  novoPlano() {
    this.planoEdicao = new IaWhatsAppPlano();
    this.planoEdicao.ativo = true;
    this.planoEdicao.seller_id = null;
  }

  editarPlano(plano: IaWhatsAppPlano) {
    this.planoEdicao = Object.assign(new IaWhatsAppPlano(), plano);
  }

  cancelarPlano() {
    this.planoEdicao = null;
  }

  salvarPlano() {
    if (this.planoEdicao == null || this.salvandoPlano) return;

    if (!this.planoEdicao.nome || this.planoEdicao.nome.trim() == "") {
      this.toastr.warning("", "Informe o nome do plano.");
      return;
    }

    if (!this.planoEdicao.valor || this.planoEdicao.valor <= 0) {
      this.toastr.warning("", "Informe um valor valido para o plano.");
      return;
    }

    this.salvandoPlano = true;
    this.iaService.salvarPlanoWhatsApp(this.planoEdicao).subscribe(salvou => {
      this.salvandoPlano = false;
      if (salvou) {
        this.toastr.success("", "Plano salvo com sucesso.");
        this.planoEdicao = null;
        this.carregarPlanos();
      }
    }, () => this.salvandoPlano = false);
  }

  alternarAtivoPlano(plano: IaWhatsAppPlano) {
    let planoAtualizado = Object.assign(new IaWhatsAppPlano(), plano);
    planoAtualizado.ativo = !plano.ativo;

    this.iaService.salvarPlanoWhatsApp(planoAtualizado).subscribe(salvou => {
      if (salvou) {
        plano.ativo = planoAtualizado.ativo;
        this.toastr.success("", plano.ativo ? "Plano ativado." : "Plano desativado.");
      }
    });
  }

  carregarAprendizado() {
    this.iaService.getAprendizadoWhatsApp().subscribe(aprendizado => {
      this.aprendizado = aprendizado || new IaAprendizadoWhatsApp();
    });

    this.iaService.getLacunasWhatsApp().subscribe(lacunas => {
      this.lacunas = lacunas || [];
    });
  }

  @ViewChild('conhecimentoEditor') conhecimentoEditorRef: ElementRef;

  /* Lacunas de conhecimento: abre o editor pre-preenchido com a pergunta e rola ate ele (fica em outra secao, acima) */
  ensinarLacuna(lacuna: IaLacuna) {
    this.conhecimentoEdicao = new IaScriptPrompt();
    this.conhecimentoEdicao.nome = lacuna.pergunta;
    this.lacunaPerguntaEmEnsino = lacuna.pergunta;

    setTimeout(() => {
      if (this.conhecimentoEditorRef != null) {
        this.conhecimentoEditorRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 0);
  }

  /* Descarta a lacuna sem criar conhecimento novo (ex.: pergunta parecida com algo que ja foi ensinado) */
  descartarLacuna(lacuna: IaLacuna) {
    if (!confirm('Descartar esta pergunta das lacunas de conhecimento?')) return;

    this.iaService.resolverLacunaWhatsApp(lacuna.pergunta).subscribe(resolvida => {
      if (resolvida) {
        this.lacunas = this.lacunas.filter(l => l.pergunta != lacuna.pergunta);
        this.toastr.success('', 'Pergunta descartada das lacunas.');
      }
    });
  }

  aplicarModoAutomatico() {
    this.configuracao.whatsapp_modo = "AUTO";
    this.salvar();
  }

  /* Dias da semana do horário comercial (0=Dom ... 6=Sáb) */

  diasSemana = [
    { valor: "1", rotulo: "Seg" },
    { valor: "2", rotulo: "Ter" },
    { valor: "3", rotulo: "Qua" },
    { valor: "4", rotulo: "Qui" },
    { valor: "5", rotulo: "Sex" },
    { valor: "6", rotulo: "Sáb" },
    { valor: "0", rotulo: "Dom" }
  ];

  isDiaAtivo(dia: string): boolean {
    return (this.configuracao.whatsapp_dias_semana || "").split(",").indexOf(dia) >= 0;
  }

  alternarDia(dia: string) {
    let dias = (this.configuracao.whatsapp_dias_semana || "").split(",").filter(d => d != "");
    let indice = dias.indexOf(dia);

    if (indice >= 0) {
      dias.splice(indice, 1);
    } else {
      dias.push(dia);
    }

    this.configuracao.whatsapp_dias_semana = dias.join(",");
  }

  /* Base de conhecimento (WhatsApp) */

  carregarConhecimentos() {
    this.iaService.getConhecimentosWhatsApp().subscribe(conhecimentos => {
      this.conhecimentos = conhecimentos || [];
    });
  }

  novoConhecimento() {
    this.conhecimentoEdicao = new IaScriptPrompt();
    this.conhecimentoEdicao.seller_id = null;
  }

  editarConhecimento(conhecimento: IaScriptPrompt) {
    this.conhecimentoEdicao = Object.assign(new IaScriptPrompt(), conhecimento);
  }

  cancelarConhecimento() {
    this.conhecimentoEdicao = null;
    this.lacunaPerguntaEmEnsino = null;
  }

  salvarConhecimento() {
    if (this.conhecimentoEdicao == null || this.salvandoConhecimento) return;

    if (!this.conhecimentoEdicao.nome || this.conhecimentoEdicao.nome.trim() == "") {
      this.toastr.warning("", "Informe o nome do conhecimento.");
      return;
    }

    if (this.conhecimentoEdicao.tipo == "CONTEUDO" && (!this.conhecimentoEdicao.prompt || this.conhecimentoEdicao.prompt.trim() == "")) {
      this.toastr.warning("", "Informe o conteudo do conhecimento.");
      return;
    }

    this.salvandoConhecimento = true;
    this.iaService.salvarConhecimentoWhatsApp(this.conhecimentoEdicao).subscribe(salvou => {
      this.salvandoConhecimento = false;
      if (salvou) {
        this.toastr.success("", "Conhecimento salvo com sucesso.");
        this.conhecimentoEdicao = null;
        this.carregarConhecimentos();

        /* Ensinar a partir de uma lacuna: marca a pergunta como resolvida */
        if (this.lacunaPerguntaEmEnsino != null) {
          this.iaService.resolverLacunaWhatsApp(this.lacunaPerguntaEmEnsino).subscribe(() => this.carregarAprendizado());
          this.lacunaPerguntaEmEnsino = null;
        }
      }
    }, () => this.salvandoConhecimento = false);
  }

  conhecimentoTemImagem(conhecimento: IaScriptPrompt): boolean {
    return !!conhecimento && (conhecimento.arquivo_mime || "").toLowerCase().indexOf("image/") === 0;
  }

  selecionarArquivoConhecimento(event: any, somenteImagem: boolean = false) {
    if (this.enviandoArquivo || this.conhecimentoEdicao == null || event == null || event.target == null || event.target.files == null || event.target.files.length == 0) {
      return;
    }

    let arquivo: File = event.target.files[0];
    event.target.value = "";

    if (somenteImagem && arquivo.type !== "image/jpeg" && arquivo.type !== "image/png") {
      this.toastr.warning("", "Selecione uma imagem JPG ou PNG.");
      return;
    }

    if (arquivo.size > 10 * 1024 * 1024) {
      this.toastr.warning("", "O arquivo excede o limite de 10 MB.");
      return;
    }

    const conhecimento = this.conhecimentoEdicao;
    this.enviandoArquivo = true;
    this.iaService.uploadConhecimentoArquivo(arquivo).subscribe(resultado => {
      this.enviandoArquivo = false;

      if (resultado != null && this.conhecimentoEdicao === conhecimento) {
        this.conhecimentoEdicao.arquivo_url = resultado.arquivo_url;
        this.conhecimentoEdicao.arquivo_nome = resultado.arquivo_nome;
        this.conhecimentoEdicao.arquivo_mime = resultado.arquivo_mime;
        this.toastr.success("", "Arquivo anexado. Salve o conhecimento para confirmar.");
      }
    }, () => this.enviandoArquivo = false);
  }

  removerArquivoConhecimento() {
    if (this.conhecimentoEdicao == null) return;

    this.conhecimentoEdicao.arquivo_url = null;
    this.conhecimentoEdicao.arquivo_nome = null;
    this.conhecimentoEdicao.arquivo_mime = null;
  }

  removerConhecimento(conhecimento: IaScriptPrompt) {
    if (conhecimento == null || !confirm("Remover o conhecimento \"" + conhecimento.nome + "\"?")) return;

    this.iaService.removerConhecimentoWhatsApp(conhecimento).subscribe(removeu => {
      if (removeu) {
        this.toastr.success("", "Conhecimento removido.");
        this.carregarConhecimentos();
      }
    });
  }

  salvar() {
    if (!this.configuracao.prompt_sistema || this.configuracao.prompt_sistema.trim() == "") {
      this.toastr.warning("", "Informe o prompt do sistema.");
      return;
    }

    if (!this.configuracao.prompt_chat_geral || this.configuracao.prompt_chat_geral.trim() == "") {
      this.toastr.warning("", "Informe o script IA - Chat geral.");
      return;
    }

    if (!this.configuracao.prompt_sugestao_produtos || this.configuracao.prompt_sugestao_produtos.trim() == "") {
      this.toastr.warning("", "Informe o script IA - Sugestao de produtos.");
      return;
    }

    this.salvando = true;
    this.iaService.upsertConfiguration(this.configuracao).subscribe(salvou => {
      this.salvando = false;
      if (salvou) {
        this.toastr.success("", "Configuracao da IA salva com sucesso.");
        this.carregar();
      }
    }, () => this.salvando = false);
  }
}
